<template>
    <div :class="[$style['mds-layout-grid__row'], classObject]" :data-mds-version="version">
        <slot></slot>
    </div>
</template>
<script>
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsRow',
        inject: ['parent'],
        data() {
            return {
                version: `${name}-${version}`,
            };
        },
        props: {
            alignHorizontal: {
                type: String,
                validator(value) {
                    return ['center', 'flex-end', 'space-around', 'space-between'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `center`, `flex-end`, `space-around`, `space-between`.',
                    description: 'Sets the `justify-content` behavior for the content of the row.',
                },
            },
            alignVertical: {
                type: String,
                validator(value) {
                    return ['flex-start', 'center', 'flex-end'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `flex-start`, `center`, `flex-end`.',
                    description: 'Sets the `align-items` behavior for the content of the row.',
                },
            },
            nowrap: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, prevents a row with more than 12 columns of content from wrapping.',
                },
            },
        },
        computed: {
            classObject() {
                const obj = {};
                const baseClassName = 'mds-layout-grid__row';
                obj[this.$style[`${baseClassName}--nowrap`]] = this.nowrap;
                obj[this.$style[`${baseClassName}--justify-content-${this.alignHorizontal}`]] = this.alignHorizontal;
                obj[this.$style[`${baseClassName}--align-items-${this.alignVertical}`]] = this.alignVertical;
                obj[this.$style[`${baseClassName}--zero-margin`]] = this.parent.gutters === 'none';
                return obj;
            },
        },
    };
</script>

<style lang="scss" module>
    @import './layout-grid.scss';
</style>
